import styled from "styled-components";
import { deviceSizesMin } from "../../../../DeviceSizes";

export const FantasyArticlesHeader = styled.div`
  width: 95%;
  margin: auto auto auto auto;
  text-align: center;
  padding-top: 10px;

  @media only screen and ${deviceSizesMin.laptopL} {
    width: 1170px;
    margin: auto auto 50px auto;
    padding-top: 50px;
  }
`;

export const FantasyArticlesTitle = styled.h1`
  padding-bottom: 15px;

  @media only screen and ${deviceSizesMin.laptopL} {
    padding-bottom: 25px;
  }
`;

export const FantasyArticlesCreateButton = styled.a`
  border: 2px solid black;
  color: black;

  margin: auto auto 10px auto;

  display: flex;
  justify-content: center;
  height: 45px;
  width: 180px;
  font-size: 14px;
  font-weight: bolder;
  letter-spacing: 1.14px;
  line-height: 20px;
  text-transform: uppercase;

  align-items: center;
  transition: all 0.2s;
  cursor: pointer;

  text-decoration: none;
  background: transparent;

  &:hover {
    color: white;
    background: black;
    box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.05);
  }
`;
